import React, {FormEvent} from 'react';
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {connect} from "react-redux";
import {loadStripe, StripeCardElement} from "@stripe/stripe-js";
import {Elements, CardElement, useStripe, useElements} from "@stripe/react-stripe-js";
import {Button, Paper, Typography, FormControl, CircularProgress, TextField} from "@material-ui/core";
import "./payments_styles.css"
import {INotificacion} from "../../types";
import axios from "axios";
import config from "../../config.json";
import {userService} from "../../services/UserService";
import {MailOutlineRounded, ShoppingCartRounded} from "@material-ui/icons";

const stripePromise = loadStripe("pk_live_51LAXYgG78blo32nsa8LsHB8WGuYpzlqa3xPkx4r6ncov8xL32gQiItRIM1ZP6uVHz0uY1KUN3FCkyUtNgLSvWTyQ00ZLJn9WbS")
// test
// const stripePromise = loadStripe("pk_test_51LAXYgG78blo32nstafh4oT83jXMZIdGyLrsBiKGLRJEMpXYUcthmSe0tfxawdzTTaMAIusC1ytA7fuQH65ny34000DBienMkL")

const cardElementOptions = {
    style: {
        base: {
            fontSize: "16px",
        },
        invalid: {
            fontSize: "16px",
        }
    }
}


interface IProps {
    user: string
    plan: number
    precio: number
    parcelas: number
    superficie: number
    duracion: number
    email: string
    location: string
    text: Record<string, string>
    notify(notification: INotificacion): void
    createAccount(): Promise<void>
    setContacta(contacta: boolean): void
    setUser(user: string): void
    setGo2App(gotoapp: boolean): void
    setLoading(loading: boolean): void
    setEmail(email: string): void
}



const emailValidation = (email: string) : boolean => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return !(!email || !regex.test(email));
}


const CheckoutForm = (props: IProps) => {

    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e: FormEvent) => {

        if (!(props.email.length > 0) || !emailValidation(props.email)) {
            props.notify({message: props.text["73"], variant: 'warning'})
            return
        } else {

            e.preventDefault()

            if (stripe !== null && elements !== null && elements.getElement(CardElement) !== undefined) {
                const {error, paymentMethod} = await stripe.createPaymentMethod({
                    type: "card",
                    card: elements.getElement(CardElement) as StripeCardElement
                })

                props.setLoading(true)

                if (!error && paymentMethod !== undefined) {

                    props.createAccount()
                        .then(() => {
                            const data = {
                                id: paymentMethod.id,
                                email: props.email,
                                user: props.user,
                                pais: paymentMethod?.card?.country?.toLowerCase(),
                                precio: Math.round(props.precio * 100),
                                plan: props.plan,
                                superficie: props.superficie,
                                parcelas: props.parcelas,
                                duracion: props.duracion
                            }

                            axios.post(
                                config.url+`/payment/card`,
                                data,
                                {auth: {
                                        username: `${userService.getUser()}`,
                                        password: `${userService.getPass()}`
                                    }
                                })
                                .then(() => {
                                    props.setLoading(false)
                                    props.notify({message: props.text["74"], variant: 'success'})

                                    if (!window.location.pathname.split("/").includes("register")) {
                                        props.setUser(props.user)
                                        props.setContacta(false)
                                    } else {
                                        props.setGo2App(true)
                                    }

                                })
                                .catch(() => {
                                    props.setLoading(false)
                                    props.notify({message: props.text["75"], variant: 'error'})
                                })
                        })
                        .catch(() => {
                            props.setLoading(false)
                            props.notify({message: props.text["76"], variant: 'warning'})
                        })

                } else {
                    props.setLoading(false)
                    props.notify({message: props.text["76"], variant: 'warning'})
                }
            }
        }
    }

    return (
        <form
            onSubmit={(e) => handleSubmit(e)}
        >
            <CardElement
                options={cardElementOptions}
                className={"form-custom"}
            />

            <button
                className={"pay-button"}
            >
                <ShoppingCartRounded
                />
                <Typography
                    style={{
                        fontSize: 18,
                        fontWeight: "bold",
                        margin: 5
                    }}
                >
                    {props.text["77"]}
                </Typography>
            </button>

        </form>
    )
}


function Payments(props: IProps) {

    return (
        <Elements stripe={stripePromise}>
            <link rel="stylesheet"
                  href="https://fonts.googleapis.com/css?family=Poppins"
            />
            <Paper
                elevation={3}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: 400,
                    height: "fit-content",
                    borderRadius: 20
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        margin: 20
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 18,
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                width: 150,
                                textAlign: "start"
                            }}
                        >
                            {props.text["78"]}
                        </Typography>
                        <Typography
                            style={{
                                textAlign: "start",
                                fontSize: 18,
                                fontFamily: "Poppins"
                            }}
                        >
                            {props.precio + " €"}
                        </Typography>

                    </div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "flex-end"
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: 18,
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                width: 150,
                                textAlign: "start",
                            }}
                        >
                            {props.text["79"]} (21%):
                        </Typography>
                        <Typography
                            style={{
                                textAlign: "start",
                                fontSize: 18,
                                fontFamily: "Poppins",
                                width: 80
                            }}
                        >
                            {Math.round(props.precio * 0.21*100)/100 + " €"}
                        </Typography>
                        <Typography
                            style={{
                                fontSize: 14,
                                fontWeight: "bold",
                                fontFamily: "Poppins",
                                textAlign: "start",
                                marginBottom: 2
                            }}
                        >
                            {props.text["80"]}
                        </Typography>

                    </div>

                    {/*{props.location === "es" &&*/}
                    {/*    <div*/}
                    {/*        style={{*/}
                    {/*            display: "flex",*/}
                    {/*            flexDirection: "row",*/}
                    {/*            alignItems: "center"*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <Typography*/}
                    {/*            style={{*/}
                    {/*                fontSize: 18,*/}
                    {/*                fontWeight: "bold",*/}
                    {/*                fontFamily: "Poppins",*/}
                    {/*                width: 150,*/}
                    {/*                textAlign: "start"*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            Total:*/}
                    {/*        </Typography>*/}
                    {/*        <Typography*/}
                    {/*            style={{*/}
                    {/*                textAlign: "start",*/}
                    {/*                fontSize: 18,*/}
                    {/*                fontFamily: "Poppins"*/}
                    {/*            }}*/}
                    {/*        >*/}
                    {/*            {Math.round(props.precio * 1.21 * 100) / 100 + " €"}*/}
                    {/*        </Typography>*/}

                    {/*    </div>*/}
                    {/*}*/}

                </div>

                <div
                    style={{
                        margin: 20
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "fit-content",
                            width: "100%",
                            marginBottom: 10,
                            backgroundColor: "#eee",
                            borderRadius: 10
                        }}
                    >
                        <MailOutlineRounded
                            style={{
                                marginLeft: 10,
                                width: 25,
                                height: 25,
                                color: "#888"
                            }}
                        />

                        <TextField
                            label={props.text["81"]}
                            style={{
                                width: '100%',
                                marginTop: -12,
                                marginBottom: 4,
                                marginLeft: -3
                            }}
                            inputProps={{style: {fontSize: 16, marginLeft: 10}}}
                            InputLabelProps={{style: {fontSize: 16, marginLeft: 10}}}
                            InputProps={{disableUnderline: true}}
                            value={props.email}
                            onChange={e => {
                                props.setEmail(e.target.value)
                            }}
                        />
                    </div>
                    <CheckoutForm
                        user={props.user}
                        plan={props.plan}
                        precio={props.precio}
                        parcelas={props.parcelas}
                        superficie={props.superficie}
                        duracion={props.duracion}
                        email={props.email}
                        location={props.location}
                        text={props.text}
                        createAccount={props.createAccount}
                        setContacta={props.setContacta}
                        setUser={props.setUser}
                        setGo2App={props.setGo2App}
                        setLoading={props.setLoading}
                        setEmail={props.setEmail}
                        notify={props.notify}
                    />
                </div>
            </Paper>
        </Elements>
    )


}


export default Payments;
